// extracted by mini-css-extract-plugin
module.exports = {"sve2lzs":"sve2lzs"};